<template>

<div class="setting" v-click-outside="onOutsideClick">
        
    <div class="setting-text" v-on:click="onTextClick" v-tooltip="tooltip || 'Click to change'">
    
        <span>{{ text }}</span>

        <i class="setting-icon fa fa-caret-down" :class="{'is-active': expanded}" />
    
    </div>

    <core-filter-advanced-builder-dropdown :options="optionsFinal" v-on:change="onChange" v-if="expanded" />

</div>

</template>

<script>

import vClickOutside from 'v-click-outside'

export default {

	directives: {
		clickOutside: vClickOutside.directive
	},

    props: ['options', 'tooltip', 'value'],

    data: function() {

        return {
            expanded: false,
            selected: false
        }

    },

    created: function() {

        this.selected = this.value

    },

    watch: {

        value: function(n) {

            this.selected = n

        }

    },

    computed: {

        optionsFinal: function() {

            return this.options

        },

        optionSelected: function() {

            return this.$_.findWhere(this.options, {
                value: this.selected
            })

        },

        text: function() {

            return this.optionSelected.text

        }

    },

    methods: {
        
        onChange: function(value) {

            this.$emit('change', value)
            this.expanded = false

        },

        onOutsideClick: function() {

            this.expanded = false

        },

        onTextClick: function() {

            this.expanded = !this.expanded

        }

    }

}

</script>

<style scoped>

.setting {
}

.setting-text {
    padding: 0px 10px;
    line-height: 40px;
    font-size: 14px;
    color: #fff;
    font-weight: 400;
    border-radius: 4px;
    cursor: pointer;
    user-select: none;
    background-color: rgba(0, 0, 0, 0.15);
}

.is-desktop .setting-text:hover {
    background-color: rgba(0, 0, 0, 0.25);
}

.setting-icon {
    position: absolute;
    right: 8px;
    top: 0px;
    font-size: 16px;
    width: 20px;
    text-align: center;
    line-height: 40px;
    color: rgba(255, 255, 255, 0.25);
}

.setting-text:hover .setting-icon.is-active {
    color: #fff;
}

</style>